import React, {useEffect, useRef, useState} from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Importa o CSS do Quill
import './style.css';
import Grid from "@material-ui/core/Grid";

interface QuillConfig {
    modules?: Record<string, any>;
    formats?: string[];
}

interface EditorQuillProps {
    maxLength?: number;
    showMaxLength?: boolean;
    required?: boolean;
    value?: string;
    label?: string | any;
    placeholder?: string;
    onChange?: (value: any) => void;
    config?: QuillConfig
}


const EditorQuill: React.FC<EditorQuillProps> = ({
     config,
     required,
     label,
     maxLength = null,
     showMaxLength = false,
     placeholder,
     value = '',
     onChange = () => {}
     }) => {

    // eslint-disable-next-line
    const [currentValue, setCurrentValue] = useState<number>(0);
    const quillRef = useRef<ReactQuill | null>(null);

    useEffect(() => {
        const quill = quillRef.current?.getEditor();
        if (quill) {
            const initialLength = quill.getLength() - 1; // Pega o tamanho inicial
            setCurrentValue(initialLength);
        }
    }, [value]);

    const handleChange = (content: string) => {
        const quill = quillRef.current?.getEditor();
        if (!quill) return;

        const length = quill.getLength() - 1;

        if (maxLength && length > (maxLength ?? Infinity)) {
            quill.deleteText(maxLength, length); // Limita o texto ao valor de `maxLength`
        } else {
            onChange(content); // Envia o conteúdo ao componente pai
        }
    };

    return (
        <Grid container direction="column" spacing={1}>
            <Grid container alignItems="center" spacing={1} style={{ marginBottom: '16px' }}>
                <Grid item>
                    <label>
                        {label}{' '}
                        {!!required && <strong style={{ color: '#0061C6' }}>*</strong>}
                    </label>
                </Grid>
            </Grid>
            <ReactQuill
                ref={quillRef}
                value={value}
                onChange={handleChange}
                modules={config?.modules}
                formats={config?.formats}
                placeholder={placeholder}
            />
            {showMaxLength && (
                <Grid item container justifyContent="flex-end">
                    <Grid
                        item
                        xs="auto"
                        style={{
                            paddingRight: '10px',
                        }}
                    >
                        <label>
                            {`${ quillRef?.current?.value?.length ?? 0}/${maxLength}`}
                        </label>
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
};

export default EditorQuill;